import Vue from "vue";

import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadMessages() {
  const context = require.context("@/lang", true, /[a-z0-9-_]+\.json$/i);

  const messages = context
    .keys()
    .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (messages, { key, locale }) => ({
        ...messages,
        [locale]: context(key),
      }),
      {}
    );

  return { context, messages };
}

const { messages } = loadMessages();

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "vi",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "vi",
  messages,
});

export { i18n, loadMessages };
